import get from 'lodash/get';
import {
  createReqConsts,
  createActions,
  createReqWatcher,
} from '../../../utils/redux';

export const consts = createReqConsts(
  'appointment-form',
  'insurance-eligibility-payers',
);
export const actions = createActions(consts);
export const watcher = createReqWatcher(
  consts,
  actions,
  {
    endpoint: 'insurance_eligibility',
    type: 'get',
    slug: [
      'payers',
      {
        type: 'payload.query',
        queryParameter: 'query',
        selector: 'query',
      },
      {
        type: 'payload.query',
        queryParameter: 'limit',
        selector: 'limit',
      },
      {
        type: 'payload.query',
        queryParameter: 'offset',
        selector: 'offset',
      },
      {
        type: 'payload.query',
        queryParameter: 'provider_id',
        selector: 'providerId',
      },
      {
        type: 'payload.query',
        queryParameter: 'service_id',
        selector: 'serviceId',
      },
      {
        type: 'payload.query',
        queryParameter: 'organization_id',
        selector: 'organizationId',
      },
    ],
  },
  true,
);

const initialState = {
  sending: false,
  succeed: null,
  rejected: null,
  error: null,
  list: [],
  count: 0,
  isLastPage: false,
  meta: null,
};

export default (state = initialState, action) => {
  const { payload, type } = action;

  switch (type) {
    case consts.SEND:
      return {
        ...state,
        sending: true,
        succeed: null,
        rejected: null,
        error: null,
      };

    case consts.SUCCEED:
      return {
        ...state,
        succeed: true,
        sending: false,
        list: state.list.length ? state.list.concat(payload) : payload,
      };

    case consts.REJECTED:
      return {
        ...state,
        sending: false,
        rejected: true,
      };

    case consts.ERROR_ENCOUNTERED:
      return {
        ...state,
        sending: false,
        error: payload,
      };

    case consts.ADD_META: {
      const total = get(action.payload, 'total', 0);

      return {
        ...state,
        meta: action.payload,
        count: total,
        isLastPage: state.list.length === total,
      };
    }

    case consts.CLEAR:
      return initialState;

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/appointmentForm/requests/insurance-payers-req.js